const initialState = {
  resultsUsersList: [],
  resultsUser: {},
  resultsUserByEmail: {},
  resultsUserPermissions: {},
  resultsUserPatch: {},
  resultsUserCreate: {},
  resultsPasswordStatus: {}
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_USER_RESPONSE_GET":
      newState.resultsUsersList = action.value;
      break;
    case "PASSWORD_UPDATE":
      newState.resultsPasswordStatus = action.value;
      break;
    case "USER_RESPONSE_GET":
      newState.resultsUser = action.value;
      break;
    case "USER_RESPONSE_BY_EMAIL_GET":
      newState.resultsUserByEmail = action.value;
      break;
    case "USER_PERMISSIONS_RESPONSE_GET":
      newState.resultsUserPermissions = action.value;
      break;
    case "USER_RESPONSE_RESET":
      newState.resultsUser = {};
      newState.resultsUserByEmail = {};
      break;
    case "USER_RESPONSE_UPDATE":
      newState.resultsUserPatch = action.value;
      break;
    case "USER_RESPONSE_CREATE":
      newState.resultsUserCreate = action.value;
      break;
    case "RESET_USER_RESPONSES":
      newState.resultsUserCreate = {};
      newState.resultsUserPatch = {};
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
